var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartNormal',{attrs:{"size":"12","offset":"0","title":"Warranty Repair","chart":"column","chartType":"warranty-repair","isCity":false,"withDate":true,"withFinancial":false,"warrantyRepair":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }